import React from 'react'
import { HamburgerMD, CloseMD } from '../normalizer'

const Burger = ({ onClick, open }) => {
  const Icon = open ? CloseMD : HamburgerMD
  return (
    <button
      type="button"
      className="gl-burger gl-outline-reset"
      aria-label={open ? 'Fechar menu' : 'Abrir menu'}
      aria-expanded={!!open}
      onClick={onClick}
    >
      <Icon className="gl-burger__icon" />
    </button>
  )
}

export default Burger
